// extracted by mini-css-extract-plugin
module.exports = {"accessDenied":"NotFoundPage_accessDenied__1f36m","image":"NotFoundPage_image__9uiIv","title":"NotFoundPage_title__3fpdX","link":"NotFoundPage_link__IenET"};